import React, { FunctionComponent, useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Paperbase, { PageType } from './material-ui/Paperbase';
import NotificationHandler from './material-ui/NotificationHandler';
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { NavigatorData } from './material-ui/NavigatorData';
import { AuthContext } from './material-ui/AuthContext';
import useGTM from '@elgorditosalsero/react-gtm-hook'

declare global {
  interface Window { ATL_JQ_PAGE_PROPS: any; }
}

window.ATL_JQ_PAGE_PROPS = window.ATL_JQ_PAGE_PROPS || {};

const notificationHandler = new NotificationHandler();

// top-level component

const App: FunctionComponent = () => {

  const authContext = React.useContext(AuthContext);

  const { init, UseGTMHookProvider } = useGTM()

  useEffect(() => init({ id: 'GTM-5N26MG' }), [])


  function handleAuthentication() {
    if (/access_token|id_token|error/.test(window.location.hash)) {
      authContext.handleAuthentication();
    }
  };

  React.useEffect(() => {
      authContext.refreshSession();
  }, []);
  

  React.useEffect(() => {
    const collectorScript = document.createElement('script');
    collectorScript.src = "https://deltaxml.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/o2joag/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=f1d98674";
    collectorScript.async = true;
    document.body.appendChild(collectorScript);

    const feedbackButtonScript = document.createElement('script');
    feedbackButtonScript.type = "text/javascript";
    feedbackButtonScript.text = 'window.ATL_JQ_PAGE_PROPS={"triggerFunction":function(showCollectorDialog){jQuery("#feedbackButton").click(function(e){e.preventDefault();showCollectorDialog()})}}';
    document.body.appendChild(feedbackButtonScript);
    return () => {
      document.body.removeChild(collectorScript);
      document.body.removeChild(feedbackButtonScript);
    }
  }, []);

  return (
  <UseGTMHookProvider>
    <Router>
      <AuthContext.Provider value={authContext}>
      <div className="App">
        <ReactNotification />
        <Switch>
          <Route path={NavigatorData.welcomBaseUrl} >
            <Paperbase headerType={PageType.Welcome} notificationHandler={notificationHandler} />
          </Route>
          <Route path={NavigatorData.configBaseUrl}>
            <Paperbase headerType={PageType.Configuration} notificationHandler={notificationHandler} />
          </Route>
          <Route path={NavigatorData.filesBaseUrl}>
            <Paperbase headerType={PageType.Files} notificationHandler={notificationHandler} />
          </Route>
          {/* <Route path={NavigatorData.sessionJobsBaseUrl}>
            <Paperbase headerType={PageType.SessionJobs} notificationHandler={notificationHandler} />
          </Route> */}
          <Route path={NavigatorData.jobsHistoryBaseUrl}>
            <Paperbase headerType={PageType.JobsHistory} notificationHandler={notificationHandler} />
          </Route>
          <Route path={NavigatorData.logsBaseUrl}>
            <Paperbase headerType={PageType.Logs} notificationHandler={notificationHandler} />
          </Route>
          <Route
            path={NavigatorData.callbackBaseUrl}
            render={() => {
              handleAuthentication();
              return <Redirect to="/" />;
            }}
          />
          <Route path="/">
            <Paperbase headerType={PageType.Welcome} notificationHandler={notificationHandler} />
          </Route>
        </Switch>
      </div>
      </AuthContext.Provider>
    </Router>
  </UseGTMHookProvider>
  );
}

export default App;

